/*document.addEventListener('giftship.loaded', function() {
//document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
   //console.log('data ='+urlParams.get('gift'));
  const isGiftMode = urlParams.get('gift');
  if (!isGiftMode) return;

  document.body.classList.add('gift-mode');

  const variantToHide = 'Single Glass'; // change to the variant title you want hidden

  // --- 1  Wait until Giftship loads ---
  function waitForGiftship(maxAttempts = 20) {
    let attempts = 0;
    const interval = setInterval(() => {
      const giftship = document.querySelector('.gs__product-app-container');
      if (giftship) {
        giftship.style.display = 'block';
        clearInterval(interval);
        console.log('Giftship ready');
      } else if (attempts++ >= maxAttempts) {
        console.warn(' Giftship not found');
        clearInterval(interval);
      }
    }, 500);
  }
  waitForGiftship();

  // --- 2️ Wait until variant picker loads, then hide one variant ---
  function hideVariant() {
    // Dropdown picker
    document.querySelectorAll('select[name="id"] option').forEach(opt => {
      if (opt.textContent.includes(variantToHide)) opt.remove();
    });

    // Radio-button or swatch pickers
    document.querySelectorAll('[data-option-label]').forEach(label => {
      if (label.textContent.includes(variantToHide)) {
        label.closest('[data-option]').remove();
      }
    });

    // Some themes (like Dawn) use fieldsets
    document.querySelectorAll('fieldset label').forEach(label => {
      if (label.textContent.includes(variantToHide)) {
        label.closest('fieldset > div, label').remove();
      }
    });

    const gift_message_product =  localStorage.getItem("gft_message");
    if(gift_message_product!=''){
        const gift_message_pro = document.querySelector('#gsMessage');
        gift_message_pro.value = gift_message_product;
        gift_message_pro.dispatchEvent(new Event('input', { bubbles: true })); 
    }
  }

  function waitForVariants(maxAttempts = 20) {
    let attempts = 0;
    const interval = setInterval(() => {
      const hasVariants =
        document.querySelector('select[name="id"] option') ||
        document.querySelector('fieldset label');
      if (hasVariants) {
        hideVariant();
        clearInterval(interval);
        console.log('Variant hidden');
      } else if (attempts++ >= maxAttempts) {
        clearInterval(interval);
        console.warn('Variant picker not found');
      }
    }, 500);
  }
  waitForVariants();
});*/

/*code start for box builder*/
/*
(function() {
  // --- 1️ Check for query parameter "gift" ---
  const urlParams = new URLSearchParams(window.location.search);
  const isGiftMode = urlParams.get('gift');
  const urlContainsBuilder = window.location.href.toLowerCase().includes('builder');
  if (!isGiftMode || !urlContainsBuilder) {
    console.log('⏸ Gift mode not enabled — skipping Giftship enhancements.');
    return;
  }

  console.log(' Gift mode enabled — running Giftship enhancements...');
  document.body.classList.add('gift-mode');

  // --- 2️ Config ---
  const storeMessageKey = 'message'; // key in localStorage
  const hiddenVariantName = 'Single Glass';

  // --- 3️ Prefill message ---
  function setGiftMessage(container) {
    const message = localStorage.getItem(storeMessageKey);
    if (!message) return;

    // Try different possible selectors
    const inputSelectors = [
      'textarea[name*="Gift Message"]',
      'input[name*="message"]',
      '#gsMessage',
      '.gs__gift-message textarea',
      '.gs__gift-message input',
      '.gs__fs-input'
    ];

    for (const sel of inputSelectors) {
      const input = container.querySelector(sel);
      if (input) {
        input.value = message;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus();
        console.log('Gift message auto-filled:', message);
        return;
      }
    }
  }

  // --- 4️ Hide "Single Glass" variant ---
  function hideSingleGlassVariant(container) {
    if (!container) return;

    // Dropdown picker
    container.querySelectorAll('select[name="id"] option').forEach(opt => {
      if (opt.textContent.trim().toLowerCase() === hiddenVariantName.toLowerCase()) {
        console.log('Hiding dropdown variant:', opt.textContent);
        opt.remove();
      }
    });

    // Radio/swatch pickers
    container.querySelectorAll('[data-option-label], .product-variant-option, .swatch-element, .gs__pm-radio-input, .gs__pm-input-container').forEach(label => {
      const text = label.textContent.trim().toLowerCase();
      if (text === hiddenVariantName.toLowerCase()) {
        console.log(' Hiding radio/swatch variant:', text);
        const parent = label.closest('[data-option]') || label.closest('fieldset > div') || label;
        if (parent) parent.remove();
      }
    });
  }

  // --- 5️ Run enhancements after Giftship loads ---
  function runGiftshipEnhancements() {
    const container =
      document.querySelector('.gs__product-app-container') ||
      document.querySelector('.giftship-modal') ||
      document.querySelector('.gs__box-builder') ||
      document.querySelector('.gs-builder-popup');

    if (!container) return;

    // Initial run
    setGiftMessage(container);
    hideSingleGlassVariant(container);

    // Watch for dynamic changes inside builder
    const observer = new MutationObserver(() => {
      setGiftMessage(container);
      hideSingleGlassVariant(container);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  // --- 6 Giftship Event API hooks ---
  document.addEventListener('giftship.loaded', runGiftshipEnhancements);
  document.addEventListener('giftship.reloaded', runGiftshipEnhancements);
  document.addEventListener('giftship.builder.contents-loaded', runGiftshipEnhancements);
  document.addEventListener('giftship.builder.step-loaded', runGiftshipEnhancements);

  // --- 7️ Fallback if builder already exists ---
  function waitForGiftship(maxAttempts = 20, intervalTime = 500) {
    let attempts = 0;
    const interval = setInterval(() => {
      const giftship = document.querySelector('.gs__box-builder');
      if (giftship) {
        runGiftshipEnhancements();
        clearInterval(interval);
        console.log(' Giftship container ready');
      } else if (attempts++ >= maxAttempts) {
        clearInterval(interval);
        console.warn('Giftship container not found');
      }
    }, intervalTime);
  }

  waitForGiftship();

})();
*/

(function () {
  // Run only when gift query param present
  const urlParams = new URLSearchParams(window.location.search);
  const isGiftMode = urlParams.get('gift');
  const urlContainsBuilder = window.location.href.includes('builder');
  if (!isGiftMode || !urlContainsBuilder) return;
  console.log('Gift mode active — applying enhancements');

  const STORAGE_KEY = 'message'; // your localStorage key
  const HIDDEN_VARIANT = 'Single Glass';

  // Safely set value using the native property setter (works with React-controlled inputs)
  function setNativeValue(el, value) {
    if (!el) return false;
    const prototype = Object.getPrototypeOf(el);
    const valueSetter = Object.getOwnPropertyDescriptor(
      prototype,
      'value',
    )?.set;
    if (valueSetter) {
      valueSetter.call(el, value);
    } else {
      el.value = value;
    }
    return true;
  }

  // Apply message to first matching field inside container
  function applyMessage(container, message) {
    if (!message || !container) return false;
    const selectors = [
      '#gsMessage',
      'textarea[name*="message"]',
      'input[name*="message"]',
      '.gs__gift-message textarea',
      '.gs__gift-message input',
      'textarea',
      'input[type="text"]',
      '.gs__fs-input',
    ];
    for (const sel of selectors) {
      const field = container.querySelector(sel);
      if (field) {
        setNativeValue(field, message);
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
        // force sync
        try {
          field.focus();
          field.blur();
        } catch (e) {}
        console.log('set message into', sel, message);
        return true;
      }
    }
    return false;
  }

  // Robustly hide variant labels/options that match HIDDEN_VARIANT
  function hideVariant(container) {
    if (!container) return;
    const lower = HIDDEN_VARIANT.toLowerCase();

    // selects
    container.querySelectorAll('select option').forEach((opt) => {
      if (
        opt.textContent &&
        opt.textContent.trim().toLowerCase().includes(lower)
      ) {
        opt.disabled = true;
        opt.style.display = 'none';
        console.log('Hid select option:', opt.textContent.trim());
        // if selected, try to select another
        if (opt.selected) {
          const next = Array.from(opt.parentElement.options).find(
            (o) => !o.disabled && o.value,
          );
          if (next) {
            setNativeValue(opt.parentElement, next.value);
            opt.parentElement.dispatchEvent(
              new Event('change', { bubbles: true }),
            );
          }
        }
      }
    });

    // labels / swatches / radios
    container
      .querySelectorAll(
        'label, .swatch-element, .product-variant-option, [data-option-label]',
      )
      .forEach((node) => {
        if (!node.textContent) return;
        if (node.textContent.trim().toLowerCase().includes(lower)) {
          const wrapper = node.closest('li') || node.closest('div') || node;
          // disable underlying input if exists
          const input =
            node.querySelector('input') ||
            (node.getAttribute && node.getAttribute('for')
              ? container.querySelector(
                  '#' + CSS.escape(node.getAttribute('for')),
                )
              : null);
          if (input) {
            try {
              input.disabled = true;
              if (input.checked) input.checked = false;
            } catch (e) {}
          }
          if (wrapper) wrapper.style.display = 'none';
          console.log('Hid variant node:', node.textContent.trim());
        }
      });
  }

  // Find main Giftship container
  function findContainer() {
    return (
      document.querySelector('.gs__product-app-container') ||
      document.querySelector('.giftship-modal') ||
      document.querySelector('.gs-builder-popup') ||
      document.querySelector('.giftship-container') ||
      document.querySelector('.gs__box-builder') ||
      document.querySelector('.product-form')
    );
  }

  // Main apply routine: attempt to apply message + hide variant and attach observer
  function attachToGiftship() {
    const container = findContainer();
    if (!container) return false;

    const message = localStorage.getItem(STORAGE_KEY);
    // initial attempt
    applyMessage(container, message);
    hideVariant(container);

    // Observe for re-renders inside the container and reapply
    const innerObs = new MutationObserver((mutations) => {
      // Small debounce using microtask
      Promise.resolve().then(() => {
        applyMessage(container, message);
        hideVariant(container);
      });
    });
    innerObs.observe(container, { childList: true, subtree: true });

    // Optional: stop after 2 minutes to avoid forever-observing
    setTimeout(() => innerObs.disconnect(), 2 * 60 * 1000);

    console.log('Attached Giftship enhancement observer');
    return true;
  }

  // If Giftship Event API is available, hook into it
  function setupEventHooks() {
    const onReady = () => {
      if (!attachToGiftship()) {
        // fallback: if container not found immediately, try waiting a little
        waitForContainerAndAttach();
      }
    };

    document.addEventListener('giftship.loaded', onReady);
    document.addEventListener('giftship.reloaded', onReady);
    document.addEventListener('giftship.builder.contents-loaded', onReady);
    document.addEventListener('giftship.builder.step-loaded', onReady);

    // If already loaded
    if (window.GSSDK && window.GSSDK.page && window.GSSDK.page.get) {
      setTimeout(onReady, 300);
    }
  }

  // Poll/fallback to detect container if events didn't fire
  function waitForContainerAndAttach(maxAttempts = 20, intervalMs = 500) {
    let attempts = 0;
    const t = setInterval(() => {
      if (attachToGiftship() || attempts++ >= maxAttempts) {
        clearInterval(t);
        if (attempts >= maxAttempts)
          console.warn('Giftship container not found after waiting');
      }
    }, intervalMs);
  }

  // Start
  try {
    setupEventHooks();
    // also run immediate attach attempt in case events won't fire
    if (!attachToGiftship()) waitForContainerAndAttach();
  } catch (err) {
    console.error('Giftship enhancement error', err);
  }
})();

/*END*/
